import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AdminService from '../../services/AdminService';

const AdminReports = () => {
   const navigate = useNavigate();
   const { t } = useTranslation();
   const handleGetNCALayerReports = async () =>  {
      try {
         const response = await AdminService.getNMReports();
         downloadResponseAsExcel(response, "nm-users.xlsx");

      } catch (e) {
         console.error('Error while downloading the report', e);
         if (e.response?.data?.status === 403) {
            navigate("/nm-auth", {
              replace: true,
            });
          }
      }
   }
   const handleGetSDKReports = async () =>  {
      try {
         const response = await AdminService.getSDKReports();
         downloadResponseAsExcel(response, "sdk-users.xlsx");
         

      } catch (e) {
         console.error('Error while downloading the report', e);
         if (e.response?.data?.status === 403) {
            navigate("/nm-auth", {
              replace: true,
            });
          } else {
            navigate("/error", {
               replace: true,
             });
          }
      }
   }

   const downloadResponseAsExcel = (response, excelName) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', excelName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
   }


   return (
      <div className="content">
         <div className=" titleCell">
            <span>{t('NCALayerModuleForm.adminReports')}</span>
         </div>
         <br></br>
         <div className="selectorContent">
         <button
               id="btn-sel"
               name="rcfield:0:checkCompanyButton"
               className="new-blue-btn-sel"
               type="submit"
               role="button"
               aria-disabled="false"
               onClick={handleGetSDKReports}
            >
               <span className="ui-button-text ui-c">{t('NCALayerModuleForm.adminSDKReport')}</span>
            </button>
      <button
               id="btn-sel"
               name="rcfield:0:checkCompanyButton"
               className="new-blue-btn-sel"
               type="submit"
               role="button"
               aria-disabled="false"
               onClick={handleGetNCALayerReports}
            >
               <span className="ui-button-text ui-c">{t('NCALayerModuleForm.adminNCALayerModuleReport')}</span>
            </button>

         </div>
      </div>
   );
};


export default AdminReports;